export interface IPromotionVas {
  name: string;
  description: string;
}

export interface IGetPromotionVasListParams {
  isTop: boolean;
  isPremium: boolean;
  isStandard: boolean;
  isAuction: boolean;
}

export const getPromotionVasList = ({
  isTop,
  isPremium,
  isStandard,
  isAuction,
}: IGetPromotionVasListParams): IPromotionVas[] => {
  const vasList: IPromotionVas[] = [];

  if (isTop) {
    vasList.push({
      name: 'Топ',
      description:
        'Топ-объявления самые заметные в результатах поиска за счёт больших фотографий и брендирования. Такие объявления показываются в 3 раза чаще обычных.',
    });
  }

  if (isPremium) {
    vasList.push({
      name: 'Премиум',
      description:
        'Премиум-объявления выделены в результатах поиска за счёт брендирования. Такие объявления показываются в 1.5 раза чаще обычных.',
    });
  }

  if (isStandard) {
    vasList.push({
      name: 'Стандарт',
      description: 'Стандарт ниже объявлений с продвижением Топ и Премиум, но выше Публикаций в результатах поиска.',
    });
  }

  if (isAuction) {
    vasList.push({
      name: 'Аукцион',
      description: 'Объявления пользователей, которые заплатили больше, показываются на более высоких позициях.',
    });
  }

  return vasList;
};
